
<div class="container-fluid">

  <div class="row">
    <div class="col">

      <div *ngIf="loadingJobRoles" class="text-center">
        <fa-duotone-icon [icon]="['fad', 'spinner']" [spin]="true" [pulse]="true" size="4x" primaryColor="darkgreen" secondaryColor="green"></fa-duotone-icon>
      </div>
      <div *ngIf="!loadingJobRoles">
        <p-table [totalRecords]="companyJobTitles?.length" #ta [value]="companyJobTitles" styleClass="p-datatable-striped p-datatable-responsive-eca"
                 [scrollable]="!isOnMobile && companyJobTitles?.length > 5" 
                 scrollHeight="500px" [responsive]="true" [columns]="columns" dataKey="id"
                 [globalFilterFields]="['name', 'updatedBy']">
          <ng-container>
            <ng-template pTemplate="caption">
              <div class="row d-flex justify-content-between align-items-center">
                <div class=" col-xl-auto col-lg-auto col-md-6 col-sm-12">
                  <div class="row  justify-content-lg-start justify-content-md-start justify-content-sm-between justify-content-between align-items-center">
                    <div class="col-auto">
                      <h5 class="eca-primary-text">
                        Job Roles
                      </h5>
                    </div>
                    <div class="col-auto">
                      <!--*ngIf="allowOperations?.canInsert"-->
                      <app-eca-ghost-btn (btnClicked)="addCompanyJobTitleEntry()" [btnText]="addButtonText"
                                         btnIcon="plus-circle" btnType="success">
                      </app-eca-ghost-btn>
                    </div>
                    <div class=" col-xl-auto col-lg-auto col-md-6 col-sm-12 ">
                      <div class="row  justify-content-lg-start justify-content-md-end justify-content-sm-between justify-content-between align-items-center">
                        <div class="col-xl-auto col-lg-auto col-md-8 col-sm-8 col-6">
                          <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" class="form-control" id="ctrlJobRoleSearchInput"
                                   placeholder="Search All"
                                   (input)="ta.filterGlobal($event.target.value, 'contains')">
                          </span>
                        </div>
                        <!--<div class="col-auto">
                          <app-eca-ghost-btn btnIcon="file-excel" btnText="Export" btnType="primary"></app-eca-ghost-btn>--><!--(btnClicked)=""-->
                        <!--</div>-->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </ng-container>
          <ng-template pTemplate="header">
            <tr>
               
              <th style="width: 70%" pSortableColumn="name">
                Job Role
                <p-sortIcon field="name"></p-sortIcon>
              </th>
              <th style="width: 15%" pSortableColumn="updatedBy">
                Add By
                <p-sortIcon field="updatedBy"></p-sortIcon>
              </th>
              <th style="width: 15%"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-companyJobTitle let-columns="columns" style="margin:15x;">
            <tr>
              <td *ngFor="let col of columns">
                <span class="p-column-title">{{col.header}}: </span>
                <span *ngIf="col.type=== 'text'">
                  {{companyJobTitle[col.field]}}
                </span>
              </td>

              <td>
                <app-eca-row-menu (viewBtnClicked)="editCompanyJobTitle(companyJobTitle)"
                                  [rowMenuItems]="rowMenuItems"
                                  (refreshCompanyJobTitleSuggested)="getAllCompanyJobTitles()"
                                  [contextItem]="companyJobTitle">
                </app-eca-row-menu>
              </td>

              <!--[rowMenuVisible]="allowOperations?.canDelete && companyJobTitles?.length > 1"-->

            </tr>
          </ng-template>
        </p-table>

      </div>
     
      
      </div>


  </div>
   




    </div>
